/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as groupSelectors } from '../../redux/ducks/group';
import { selectors as listSelectors } from '../../redux/ducks/lists/lists';

function mapStateToProps(state) {
  const colorTheme = groupSelectors.getActiveGroup(state).theme;
  const defaultColorTheme = listSelectors.getCurrentColorTheme(state);

  return {
    base_color: colorTheme.base_rgba || defaultColorTheme.base_color,
    accent_color: colorTheme.accent_rgba || defaultColorTheme.accent_color,
    highlight_color: colorTheme.highlight_rgba || defaultColorTheme.highlight_color,
  };
}

const ColorThemeStyle = (props) => {
  const { themeName, base_color, accent_color, highlight_color } = props;

  const themeModifiers = [
    {
      name: 'base',
      rgbColor: `rgb(${base_color.r}, ${base_color.g}, ${base_color.b})`,
      hoverColor: `rgb(${base_color.r}, ${base_color.g}, ${base_color.b})`,
      hoverColor05: `rgba(${base_color.r}, ${base_color.g}, ${base_color.b}, 0.05)`,
      hoverColor10: `rgba(${base_color.r}, ${base_color.g}, ${base_color.b}, 0.1)`,
    },
    {
      name: 'accent',
      rgbColor: `rgb(${accent_color.r}, ${accent_color.g}, ${accent_color.b})`,
      hoverColor: `rgb(${accent_color.r}, ${accent_color.g}, ${accent_color.b})`,
      hoverColor05: `rgba(${accent_color.r}, ${accent_color.g}, ${accent_color.b}, 0.05)`,
      hoverColor10: `rgba(${accent_color.r}, ${accent_color.g}, ${accent_color.b}, 0.1)`,
    },
    {
      name: 'highlight',
      rgbColor: `rgb(${highlight_color.r}, ${highlight_color.g}, ${highlight_color.b})`,
      hoverColor: `rgb(${highlight_color.r}, ${highlight_color.g}, ${highlight_color.b})`,
      hoverColor05: `rgba(${highlight_color.r}, ${highlight_color.g}, ${highlight_color.b}, 0.05)`,
      hoverColor10: `rgba(${highlight_color.r}, ${highlight_color.g}, ${highlight_color.b}, 0.1)`,
    },
  ];

  return (
    <style id={`style-theme-${themeName}`} type="text/css">
      {
        themeModifiers.map(({ name, rgbColor, hoverColor05, hoverColor10, hoverColor }) => `
          .theme-${themeName}.${name}.color,
          .GLOBAL_CAN_TOUCH .theme-${themeName}.${name}.color-hover:hover {
            color: ${rgbColor} !important;
          }

          .theme-${themeName}.${name}.background,
          .GLOBAL_CAN_TOUCH .theme-${themeName}.${name}.background-hover:hover {
            background-color: ${rgbColor} !important;
          }

          .theme-${themeName}.${name}.border,
          .GLOBAL_CAN_TOUCH .theme-${themeName}.${name}.border-hover:hover {
            border-color: ${rgbColor} !important;
          }

          .theme-${themeName}.${name}.border.trans-10 {
            border-color: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}-border-trans-10 {
            border-color: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}.fill,
          .GLOBAL_CAN_TOUCH .theme-${themeName}.${name}.fill-hover:hover {
            fill: ${rgbColor} !important;
          }

          .theme-${themeName}.${name}.stroke,
          .GLOBAL_CAN_TOUCH .theme-${themeName}.${name}.stroke-hover:hover {
            stroke: ${rgbColor} !important;
          }

          .theme-${themeName}.${name}.color-hover:hover {
            color: ${hoverColor} !important;
            transition: .25s ease-in-out 0s;
          }

          .theme-${themeName}.${name}.background-hover:hover {
            background-color: ${hoverColor} !important;
            transition: .25s ease-in-out 0s;
          }

          .theme-${themeName}.${name}.border-hover:hover {
            border-color: ${hoverColor} !important;
          }

          .theme-${themeName}.${name}.fill-hover:hover {
            fill: ${hoverColor} !important;
            transition: .25s ease-in-out 0s;
          }

          .theme-${themeName}.${name}.stroke-hover:hover {
            stroke: ${hoverColor} !important;
            transition: .25s ease-in-out 0s;
          }


          .theme-${themeName}.${name}.color.trans-05,
          .theme-${themeName}.${name}.color-hover.trans-05:hover {
            color: ${hoverColor05} !important;
          }

          .theme-${themeName}.${name}.background.trans-05,
          .theme-${themeName}.${name}.background-hover.trans-05:hover {
            background-color: ${hoverColor05} !important;
          }

          .theme-${themeName}.${name}.border.trans-05:hover,
          .theme-${themeName}.${name}.border-hover.trans-05:hover {
            border-color: ${hoverColor05} !important;
          }

          .theme-${themeName}.${name}.fill.trans-05:hover,
          .theme-${themeName}.${name}.fill-hover.trans-05:hover {
            fill: ${hoverColor05} !important;
          }

          .theme-${themeName}.${name}.stroke.trans-05:hover,
          .theme-${themeName}.${name}.stroke-hover.trans-05:hover {
            stroke: ${hoverColor05} !important;
          }

          .theme-${themeName}.${name}.color.trans-10,
          .theme-${themeName}.${name}.color-hover.trans-10:hover {
            color: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}.background.trans-10,
          .theme-${themeName}.${name}.background-hover.trans-10:hover {
            background-color: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}.border.trans-10:hover,
          .theme-${themeName}.${name}.border-hover.trans-10:hover {
            border-color: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}.fill.trans-10:hover,
          .theme-${themeName}.${name}.fill-hover.trans-10:hover {
            fill: ${hoverColor10} !important;
          }

          .theme-${themeName}.${name}.stroke.trans-10:hover,
          .theme-${themeName}.${name}.stroke-hover.trans-10:hover {
            stroke: ${hoverColor10} !important;
          }

        `)
      }
    </style>
  );
};
ColorThemeStyle.propTypes = {
  colorTheme: PropTypes.object,
  themeName: PropTypes.string.isRequired,
  base_color: PropTypes.object,
  accent_color: PropTypes.object,
  highlight_color: PropTypes.object,
};

export default connect(mapStateToProps)(ColorThemeStyle);
